import { Link } from '@framework/router/Next/Link';
import TruncateText from '@creditflowresearch/uilib/TruncateText';

interface IProps {
  name: string,
  url: string,
  className?: string,
  dataTest?: string,
}

const TruncateTextLinkCell = ({ name, url, className, dataTest }: IProps) => (
  <TruncateText value={ name }>
    <Link to={ url } className={ className } stopPropagation data-test={ dataTest }>
      { name }
    </Link>
  </TruncateText>
);

export default TruncateTextLinkCell;
